module.exports = __webpack_public_path__ + "static/scale-model-of-middleton-area-historical-society-in-madison-wisconsin-13a620d8125e8ad3ff5d5599db80a44f.png";